// Needs to be in a separate file to resolves circular dependencies: https://github.com/reduxjs/reselect/issues/169#issuecomment-246212998
export const editAlertFormName = 'alert.edit'